import React from 'react';
export function DeadOnArrival() {
  return <section data-id="element-740">
      <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-741">
        Dead on Arrival (DOA)
      </h2>
      <ul className="space-y-2" data-id="element-742">
        <li data-id="element-743">
          • <strong data-id="element-744">Electronics</strong> that arrive defective are eligible for{' '}
          <strong data-id="element-745">exchange only</strong>. Refunds are not available for DOA
          items.
        </li>
      </ul>
    </section>;
}